import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// Removed Ant Design imports
// Removed Text import
import reduce from 'lodash/reduce'
import set from 'lodash/set'
import React from 'react'
import { Link } from 'react-router-dom'
// Removed Layout, Collapse, Steps destructuring

import { API } from 'aws-amplify'
import moment from 'moment'
import momentTz from 'moment-timezone'
import MediaQuery from 'react-responsive'
import { useNavigate } from 'react-router-dom'
import { ReactComponent as CalendarIcon } from '../../../images/svg/calendar-event-date.svg'
import { ReactComponent as GoogleLogo } from '../../../images/svg/google-logo.svg'
import { ReactComponent as NewSync } from '../../../images/svg/new-sync.svg'
import { ReactComponent as Close } from '../../../images/svg/x-close.svg'
import { useGlobalState } from '../../../store'
import useLocalization from '../../../localization/useLocalization' // Added import
import { colorApple, colorOutlook } from '../../../utils/colors' // Added colorApple
import { faApple, faOutlook } from '../../../utils/customIcons' // Added faApple
import { syncTypeText } from '../../../utils/words'
// Added CB component imports
import { Accordion } from '../../core/components/Accordion';
import { CBSelect } from '../../core/components/CBSelect';
import { CBTag } from '../../core/components/CBTag';
import {
  CBCheckItem,
  CBColorPicker,
  CBHeader,
  CBInput,
  CBModal,
  CBRadioGroupBigCalendar,
  CBRadioGroupBigCalendarMulti, // Keep this specific component
  CBStep,
  CBSteps,
  SubmitButton,
  CBButton, // Added CBButton
  CBAlert // Added CBAlert
} from '../../core/components/cbd'
import SyncItem from '../components/SyncItem'
import SyncItemEdit from '../components/SyncItemEdit'

import { ReactComponent as Up } from '../../../images/svg/arrow-up-chevron.svg'
import SEO from '../../SEO' // Corrected path


const CBSampleEvent = ({ policy, destType, tag, color, t }) => { // Added t prop
  const tagDisplay = tag === ' ' ? '' : tag;
  return (
    <div className="flex p-2 border-2 border-neutral_4 m-2 rounded-sm">
      <div className="mr-2 flex-shrink-0">
        {color && (
          <CBColorPicker
            color={color}
            preview={true}
            type={destType}
          />
        )}
      </div>
      <div className="text-xs overflow-hidden"> {/* Added overflow hidden */}
        <div className="font-bold truncate"> {/* Added truncate */}
          {policy.includes('time') ? t('sync.preview_free_busy') : t('sync.preview_subject')} {tagDisplay}
        </div>
        {policy.includes('location') && <div className="truncate">{t('sync.preview_location')}</div>}
        {destType == 'google' && policy.includes('meeting') && (
          <div className="truncate">{t('sync.preview_online_meeting')}</div>
        )}
        <div className="text-gray-600 mt-1">{t('sync.preview_event_content')}</div>
        <div className="m-1 border border-neutral_1 p-1 text-gray-500"> {/* Simplified border */}
          {policy.includes('description') && <div className="truncate">{t('sync.preview_body_text')}</div>}
          {policy.includes('contact') && (
            <div className="truncate">
              {t('sync.preview_attendees_label')}: {t('sync.preview_attendee_example')} ===
            </div>
          )}
          {destType == 'ms' && policy.includes('meeting') && (
            <div className="truncate">{t('sync.preview_online_meeting')}</div>
          )}
          {policy.includes('reminder') && <span className="mr-1">{t('sync.preview_reminder_icon')}</span>}
          {policy.includes('private') && <span>{t('sync.preview_private_icon')}</span>}
        </div>
      </div>
    </div>
  )
}
class SyncCreatePageBatch extends React.Component {

  state = {
    sources:[],
    showModal: false,
    showAdvanced: true, // Keep advanced open by default based on original logic
    timeRangeActive: false,
    page: 0,
    lastPage: 3, // Adjusted based on steps
    farthestPage: 0,
    allCalendars: [],
    sourceCalendarTimezone: momentTz.tz.guess(),
    destCalendarTimezone: momentTz.tz.guess(),
    syncPairs: [],
    syncLegLimit: 0,
    remainingSyncs: 0,
    sync: {
      // source and destination removed as they are handled by 'sources' array
      bidirection: false, // Batch sync is typically one-way
      includeTag: true,
      includeSubject: false,
      includeDescription: false,
      includeLocation: false,
      includeReminders: false,
      fullSync: false,
      sourceColor: 'default', // Applied globally? Or per pair? Keep global for now.
      destColor: 'default', // Applied globally? Or per pair? Keep global for now.
      label: '(copy)',
      matchColors: false,
      hasFilters: false,
      syncLevel: ['free', 'tentative', 'busy', 'oof', 'workingElsewhere'],
      filterColor: 'none',
      startCutOff: -1,
      endCutOff: -1,
      excludeInvites: false
    },
    isLoading: false,
    error: null, // Added error state
    currentDate: moment(), // Added for timezone options
  }

  // Modified to return label/value objects for CBSelect
  getOptions() {
    return moment.tz.names().map((tz) => ({
      label: `${tz} (${moment.tz(this.state.currentDate, tz).format('Z z')})`,
      value: tz
    }));
  }
  componentDidMount() {
    this.setCalendarsFromProps()

    const license = this.props.license;
    const isAdmin = license.planId && license.planId.includes('admin');
    const isPremium = (license.planId && license.planId.includes('premium')) || license.trial;
    const isPro = license.planId && license.planId.includes('pro');

    let syncLegLimit = isPremium ? 16 : (isPro ? 36 : isAdmin ? 0 : 2);

    const isLegacy = !license.trial &&
      (license.planId === 'calendarbridge-test' || license.planId === 'calendarbridge-pro');

    if (isLegacy) {
      syncLegLimit = 14;
    }

    const currentSyncs = this.props.syncs ? this.props.syncs.length : 0;
    const remainingSyncs = syncLegLimit === 0 ? 999 : Math.max(0, syncLegLimit - currentSyncs);

    this.setState({
      syncLegLimit,
      remainingSyncs
    });
  }

  componentDidUpdate(prevProps) {
    if (this.props.accounts.length !== prevProps.accounts.length) {
      this.setCalendarsFromProps()
    }
  }
  // loadExistingSync is not applicable for batch create

  setCalendarsFromProps() {
    this.setState({
        allCalendars: this.props.accounts.reduce(
          (all, a) => [...all, ...a.calendars.map(c => ({...c, email: a.email}))], // Add email
          []
        ),
      }
    )
  }

  submitSync = async () => {
    this.setState({ error: null, isLoading: true });

    const {
      bidirection, includeTag, includeSubject, includeDescription, includeLocation,
      includeReminders, fullSync, allPrivate, sourceColor, destColor, label,
      includeMeeting, includeAttendees, matchColors, hasFilters, syncLevel,
      filterColor, startCutOff, endCutOff, excludeInvites
    } = this.state.sync;
    const { sourceCalendarTimezone, destCalendarTimezone } = this.state;


    try {
      const syncRequests = this.state.syncPairs.map(pair => {
        const sourceCal = pair.first;
        const destCal = pair.second;
        const editedProps = pair.editedProps || {};

        const syncTag = editedProps.tag !== undefined ? editedProps.tag : label;
        const syncDestColor = editedProps.destColor !== undefined ? editedProps.destColor : destColor;
        const syncMatchColors = editedProps.matchColors !== undefined ? editedProps.matchColors : matchColors;
        const syncFilterColor = editedProps.filterColor !== undefined ? editedProps.filterColor : filterColor;
        const currentSyncLevel = editedProps.syncLevel !== undefined ? editedProps.syncLevel : syncLevel; // Keep as array or string
        const syncExcludeInvites = editedProps.excludeInvites !== undefined ? editedProps.excludeInvites : excludeInvites;
        const syncHasFilters = editedProps.hasFilters !== undefined ? editedProps.hasFilters : hasFilters;

        let fixedTag = syncTag;
        if (fixedTag && fixedTag.trim() !== '' && fixedTag !== 'default' && !/^[\[({].*[\])}]/.test(fixedTag)) {
            fixedTag = `(${fixedTag})`;
        } else if (fixedTag === ' ') {
            fixedTag = ' ';
        }

        return {
          originalSyncId: '',
          originalTwoWay: false,
          sourceCalendarId: sourceCal.id,
          sourceCalendarDisplayName: sourceCal.name || sourceCal.summary,
          sourceCalendarType: sourceCal.calendarAccountType,
          sourceCalendarAccountId: sourceCal.calendarAccountId,
          sourceCalendarTimezone: sourceCal.timeZone || sourceCalendarTimezone,
          destCalendarId: destCal.id,
          destCalendarDisplayName: destCal.name || destCal.summary,
          destCalendarType: destCal.calendarAccountType,
          destCalendarTimezone: destCal.timeZone || destCalendarTimezone,
          destCalendarAccountId: destCal.calendarAccountId,
          policy:
            (includeSubject ? 'subject' : 'time') +
            (includeTag && fixedTag !== ' ' ? '|tag' : '') +
            (includeDescription ? '|description' : '') +
            (includeLocation ? '|location' : '') +
            (includeReminders ? '|reminder' : '') +
            (allPrivate ? '|private' : '') +
            (includeMeeting ? '|meeting' : '') +
            (includeAttendees ? '|contact' : ''),
          twoWay: bidirection, // Should likely always be false for batch
          canEditSource: sourceCal.canEdit,
          fullSync: fullSync,
          sourceColor: sourceColor || 'default',
          destColor: syncDestColor || 'default',
          label: fixedTag || 'default',
          matchColors: syncMatchColors,
          hasFilters: syncHasFilters,
          syncLevel: typeof currentSyncLevel === 'string' ? currentSyncLevel : currentSyncLevel.join('|'), // Handle array or string
          filterColor: syncFilterColor || 'none',
          startCutOff: startCutOff,
          endCutOff: endCutOff,
          excludeInvites: syncExcludeInvites
        };
      });

      await API.post('bridge', '/bridge/batch', {
        body: { syncs: syncRequests },
      });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'dashboardEvent',
        category: 'userActivity',
        action: 'createBatchSync',
        label: this.props.license.userId,
        email: this.props.license.email,
        count: syncRequests.length
      });

      window.location.href = window.location.origin + '/dashboard/syncs/';
    } catch (ex) {
      console.error("Batch sync submission failed:", ex);
      this.setState({ isLoading: false, error: ex.response?.data?.message || ex.message || 'Failed to create syncs.' });
    }
  }

  buildSyncItemForPreview = (sourceCal, destCal, editedProps = {}) => {
     const {
      bidirection, includeTag, includeSubject, includeDescription, includeLocation,
      includeReminders, fullSync, allPrivate, sourceColor, destColor, label,
      includeMeeting, includeAttendees, matchColors, hasFilters, syncLevel, filterColor,
      startCutOff, endCutOff, excludeInvites
    } = this.state.sync;
    const { sourceCalendarTimezone, destCalendarTimezone } = this.state;

    if (!sourceCal || !destCal) return null;

    // Apply edited props over default sync state
    const syncTag = editedProps.tag !== undefined ? editedProps.tag : label;
    const syncDestColor = editedProps.destColor !== undefined ? editedProps.destColor : destColor;
    const syncMatchColors = editedProps.matchColors !== undefined ? editedProps.matchColors : matchColors;
    const syncFilterColor = editedProps.filterColor !== undefined ? editedProps.filterColor : filterColor;
    const currentSyncLevel = editedProps.syncLevel !== undefined ? editedProps.syncLevel : syncLevel; // Keep as array or string
    const syncExcludeInvites = editedProps.excludeInvites !== undefined ? editedProps.excludeInvites : excludeInvites;
    const syncHasFilters = editedProps.hasFilters !== undefined ? editedProps.hasFilters : hasFilters;


    let fixedTag = syncTag;
    if (fixedTag && fixedTag.trim() !== '' && fixedTag !== 'default' && !/^[\[({].*[\])}]/.test(fixedTag)) {
        fixedTag = `(${fixedTag})`;
    } else if (fixedTag  === ' ') {
        fixedTag = ' ';
    }

    const item = {
      id: `preview-${sourceCal.id}-${destCal.id}`, // Unique preview ID
      originalTwoWay: false, // Batch is one-way
      sourceCalendarId: sourceCal.id,
      sourceCalendarName: sourceCal.name || sourceCal.summary,
      sourceCalendarType: sourceCal.calendarAccountType,
      sourceCalendarAccountId: sourceCal.calendarAccountId,
      sourceCalendarTimezone: sourceCal.timeZone || sourceCalendarTimezone,
      destCalendarId: destCal.id,
      destCalendarName: destCal.name || destCal.summary,
      destCalendarType: destCal.calendarAccountType,
      destCalendarTimezone: destCal.timeZone || destCalendarTimezone,
      destCalendarAccountId: destCal.calendarAccountId,
      securityPolicy:
        (includeSubject ? 'subject' : 'time') +
        (includeTag && fixedTag !== ' ' ? '|tag' : '') +
        (includeDescription ? '|description' : '') +
        (includeLocation ? '|location' : '') +
        (includeReminders ? '|reminder' : '') +
        (allPrivate ? '|private' : '') +
        (includeMeeting ? '|meeting' : '') +
        (includeAttendees ? '|contact' : ''),
      twoWay: false, // Batch is one-way
      canEditSource: sourceCal.canEdit,
      fullSync: fullSync,
      sourceColor: sourceColor || 'default',
      destinationColor: syncDestColor || 'default', // Use destinationColor key
      tag: fixedTag || 'default', // Use tag key
      matchColors: syncMatchColors,
      hasFilters: syncHasFilters,
      syncLevel: typeof currentSyncLevel === 'string' ? currentSyncLevel : currentSyncLevel.join('|'), // Join if array
      filterColor: syncFilterColor || 'none',
      startCutOff: startCutOff,
      endCutOff: endCutOff,
      excludeInvites: syncExcludeInvites,
      status: 'synced',
      active: true,
      sourceEmail: sourceCal.email,
      destEmail: destCal.email,
    };
    return item;
  }


  nextPage = () => {
    const { page, lastPage, farthestPage, sources } = this.state;
    if (page > farthestPage) {
      this.setState({ farthestPage: page });
    }

    if (page === 0 && sources.length > 0) {
      const pairs = this.generatePairs(sources);
      if (pairs.length === 0 && sources.length > 0) {
          alert("No valid sync pairs possible with the selected calendars (ensure some have edit permissions).");
          return; // Stay on page 0 if no pairs generated
      }
      this.setState({ syncPairs: pairs });
    }

    if (page === lastPage) {
      this.setState({ showModal: true, isLoading: false });
      return;
    } else {
      this.setState(
        { page: this.state.page + 1 },
        () => { window.scrollTo(0, 0) }
      );
    }
  }

  changePage = (page) => {
    const { farthestPage } = this.state;
    if (page > farthestPage) {
      this.setState({ farthestPage: page });
    }
    this.setState({ page });
  }

  checkFilters = () => {
    // This check might not be relevant for batch defaults, but keep structure
    const { sync } = this.state;
    let hasChanged = false;
    // Simplified check - if any filter is not default
    if (!sync.syncLevel.includes('free') || sync.syncLevel.length !== 5) hasChanged = true; // Check if default levels changed
    if (sync.excludeInvites) hasChanged = true;
    if (sync.filterColor !== 'none') hasChanged = true;
    if (sync.startCutOff !== -1) hasChanged = true;
    if (sync.endCutOff !== -1) hasChanged = true;
    return hasChanged;
  }

  changeSyncValue = (field, value) => {
    // This applies changes globally to the default sync settings
    const filterFields = ['syncLevel', 'filterColor', 'startCutOff', 'endCutOff', 'excludeInvites'];
    const filterChange = filterFields.includes(field);

    this.setState(prevState => {
        const newSyncState = { ...prevState.sync, [field]: value };
        if (field === 'includeSubject') {
            newSyncState.includeTag = !value && newSyncState.label !== ' ';
        }
        if (field === 'label') {
            newSyncState.includeTag = value !== ' ';
        }
        // No source/dest color changes needed globally for batch
        return { sync: newSyncState };
    }, () => {
        if (filterChange) {
            this.setState(prev => ({
                sync: { ...prev.sync, hasFilters: this.checkFilters() }
            }));
        }
    });
  }


  getAccountInfo = (c) => {
    if (!c || !this.props.accounts) return null;
    const account = this.props.accounts.find(a => a.calendarAccountId === c.calendarAccountId);
    if (!account) return <span className="text-xs text-red-500">{c.id} (Account missing)</span>;

    let prepend = '';
    if (c.calendarAccountType == 'google' && c.id != account.email && !c.id.endsWith('calendar.google.com')) {
      prepend = `${c.id}`;
    }

    return (
      <>
        {prepend != '' && <>from: <u>{prepend}</u> shared to:{' '}</>}
        {account.email}
        {(c.name === 'Calendar' && c.owner?.address === account.email) || c.id === account.email ? (
          <span className="block text-xs text-gray-500">Primary Calendar</span>
        ) : ''}
        <div className="flex mt-1">
          {!c.canEdit && <CBTag color="red" className="text-xs">Read Only</CBTag>}
          {c.id.endsWith('import.calendar.google.com') && <CBTag color="blue" className="text-xs">Imported</CBTag>}
        </div>
      </>
    )
  }
   generatePairs(array) {
    const pairs = [];
    for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < array.length; j++) {
            // Ensure not syncing to itself AND destination is editable
            if (i !== j && array[j].canEdit) {
                pairs.push({ first: array[i], second: array[j] });
            }
        }
    }
    // Trim pairs based on remaining syncs limit
    if (this.state.syncLegLimit > 0 && pairs.length > this.state.remainingSyncs) {
        return pairs.slice(0, this.state.remainingSyncs);
    }
    return pairs;
}


   renderComboMatrix(){
    const { t } = this.props;
    let pairs = this.state.syncPairs; // Use pairs already generated in state
    return (
      <div className="border p-4 rounded-sm mb-4">
        <div className="text-lg font-bold mb-2">
            {t('sync.batch_combinations_header_count', { count: pairs.length })}
            <div className="text-sm font-normal">
                {this.state.syncLegLimit === 0 ?
                  t('sync.batch_unlimited_syncs') :
                  t('sync.batch_remaining_syncs', { remaining: this.state.remainingSyncs, limit: this.state.syncLegLimit })}
            </div>
            <div className="text-sm font-normal">{t('sync.batch_calendars_selected', { count: this.state.sources.length })}</div>
        </div>
        <div className="max-h-60 overflow-y-auto text-sm"> {/* Adjusted text size */}
          {pairs.map((pair, index) => (
            <div key={index} className="p-2 border-b">
              <span className="font-medium">{pair.first.name || pair.first.summary}</span>
              <span className="text-neutral_3"> ({pair.first.email || pair.first.calendarAccountId})</span>
              <span className="mx-2">→</span>
              <span className="font-medium">{pair.second.name || pair.second.summary}</span>
              <span className="text-neutral_3"> ({pair.second.email || pair.second.calendarAccountId})</span>
            </div>
          ))}
        </div>
      </div>
    );
  }
  SourceForm = () => {
    const navigate = useNavigate(); // Use hook inside function component context if needed, or pass from props
    const { t, accounts } = this.props;
    const { allCalendars, sources } = this.state;

    return (
      <>
        <div style={{ marginBottom: 40 }}>
          <CBHeader
            step={1}
            label={t('sync.select_calendars')}
            buttonLabel={t('sync.cancel_sync')}
            buttonIcon={<Close />}
            buttonAction={(e) => navigate('/dashboard/syncs/')}
          />
          {accounts.length === 0 && (
              <center className="mt-8 mb-8 text-lg">
                <a onClick={() => navigate('/dashboard/accounts/new')} className="text-blue-600 hover:underline">
                  {t('sync.add_calendar_account')}
                </a>
              </center>
            )}
          {allCalendars.length > 0 && (
              <>
                <CBHeader
                  icon={<CalendarIcon />}
                  label={t('sync.batch_select_calendars')} // Updated label
                  subheader={true}
                />
                <div className="text-sm font-bold mb-2"> {/* Adjusted size */}
                  {t('sync.batch_select_description')}
                </div>
                <CBRadioGroupBigCalendarMulti
                  title=""
                  selectedCalendars={sources} // Pass selected sources
                  style={{ width: '100%', marginTop: 8, marginBottom: 8 }}
                  values={allCalendars}
                  selected={sources} // Pass selected sources again for internal logic?
                  labels={allCalendars.map(c => c.name || c.summary)}
                  icons={reduce(allCalendars, (acc, calendar) => {
                      const Component = calendar.calendarAccountType === 'google' ? <GoogleLogo className="mr-2 w-6 h-6" /> :
                                        calendar.calendarAccountType === 'ms' ? <FontAwesomeIcon className="mr-2" icon={faOutlook} size="lg" style={{ width: 24, height: 24 }} color={colorOutlook} /> :
                                        <FontAwesomeIcon className="mr-2" icon={faApple} size="lg" style={{ width: 24, height: 24 }} color={colorApple} />;
                      return set(acc, [calendar.id], Component);
                    }, {})}
                  subLabels={reduce(allCalendars, (acc, calendar) => set(acc, [calendar.id], this.getAccountInfo(calendar)), {})}
                  onChange={(calendar) => {
                    const isCurrentlySelected = sources.some(cal => cal.id === calendar.id);
                    let updatedSources;

                    if (isCurrentlySelected) {
                      updatedSources = sources.filter((cal) => cal.id !== calendar.id);
                    } else {
                       updatedSources = [...sources, calendar];
                    }

                    // Calculate pairs and check limits *before* setting state
                    const potentialPairs = this.generatePairs(updatedSources);
                    const currentSyncs = this.props.syncs ? this.props.syncs.length : 0;
                    const syncsNeeded = potentialPairs.length;
                    const limit = this.state.syncLegLimit;
                    const remainingAfterAdd = limit === 0 ? 999 : Math.max(0, limit - currentSyncs - syncsNeeded);
                    const currentRemaining = limit === 0 ? 999 : Math.max(0, limit - currentSyncs - this.state.syncPairs.length);


                    if (!isCurrentlySelected && limit !== 0 && (currentSyncs + syncsNeeded > limit)) {
                         alert(t('sync.batch_limit_exceeded_alert', { potentialCount: syncsNeeded, limit: limit }));
                         // Do not update state
                    } else {
                         this.setState({
                            sources: updatedSources,
                            syncPairs: potentialPairs, // Update pairs based on new selection
                            remainingSyncs: limit === 0 ? 999 : Math.max(0, limit - currentSyncs - potentialPairs.length) // Recalculate remaining
                         });
                    }
                  }}
                />
                {sources.length > 0 && this.renderComboMatrix()}
              </>
            )}
        </div>
      </>
    )
  }

  // DestinationForm is not needed for batch create

  // getColorOptions remains largely the same, just replace Select.Option with objects
   getColorOptions = () => {
    const { t } = this.props;
    const noneOption = { value: 'none', label: t('sync.none') };
    const msOptions = [
      { value: "Green category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#00ff00' }} /> Green category</div> },
      { value: "Yellow category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-yellow-200" /> Yellow category</div> },
      { value: "Red category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-red-500" /> Red category</div> },
      { value: "Orange category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'orange' }} /> Orange category</div> },
      { value: "Blue category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'blue' }} /> Blue category</div> },
      { value: "Purple category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'purple' }} /> Purple category</div> },
    ];
    const googleOptions = [
       { value: "11", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#D50000' }} /> Tomato</div> },
       { value: "10", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#0B8043' }} /> Basil</div> },
       { value: "9", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#3F51B5' }} /> Blueberry</div> },
       // Add other Google colors as needed
    ];

    // Batch mode might involve multiple source types, default to Google or provide combined?
    // For simplicity, defaulting to Google if not explicitly MS (might need refinement)
    // A better approach might be to disable this filter in batch mode or handle mixed types.
    // For now, let's assume the first selected source determines the options.
    if (this.state.sources.length > 0 && this.state.sources[0]?.calendarAccountType === 'ms') {
      return [noneOption, ...msOptions];
    } else {
      // Default to Google colors if source is not MS or not set yet
      return [noneOption, ...googleOptions];
    }
  }


  EventDetailForm = () => {
    const { t, license } = this.props;
    const { sync } = this.state;
    const colorOptions = this.getColorOptions();

    return (
      <>
        <CBHeader
          step={2} // Adjusted step number
          label={t('sync.select_information_sync')}
          buttonLabel={t('sync.edit_previous_step')}
          buttonIcon={<Up />}
          buttonAction={(e) => { this.setState({ page: this.state.page - 1 }) }}
        />

        <div className="p-4">
          <div className="font-sarabun mt-6 mb-6 text-sm"> {/* Adjusted size */}
            {t('sync.batch_privacy_description')} {/* Updated description */}
            {license.policy != 'all' && (
              <div className="text-red-600 mt-1">{t('sync.admin_limited_sync')}</div>
            )}
          </div>

          {(license.policy == 'all' || license.policy.includes('subject')) && (
              <div className="mb-3">
                <CBCheckItem
                  label={t('sync.field_subject')}
                  box={true}
                  border={true}
                  checked={sync.includeSubject}
                  onChange={(e) => { this.changeSyncValue('includeSubject', e) }}
                />
              </div>
            )}
          <div>
            {(license.policy == 'all' || license.policy.includes('contact')) && (
              <>
                <CBCheckItem
                  label={t('sync.field_attendees')}
                  box={true}
                  checked={sync.includeAttendees}
                  onChange={(e) => { this.changeSyncValue('includeAttendees', e) }}
                />
                <div className="font-sarabun p-2 bg-neutral_1 mb-3 text-neutral_3 text-xs"> {/* Adjusted size */}
                  {t('sync.attendees_description')}
                </div>
              </>
            )}
          </div>
          {(license.policy == 'all' || license.policy.includes('description')) && (
            <div className="mb-3">
              <CBCheckItem
                label={t('sync.field_description')}
                box={true}
                checked={sync.includeDescription}
                onChange={(e) => { this.changeSyncValue('includeDescription', e) }}
              />
            </div>
          )}
          {(license.policy == 'all' || license.policy.includes('location')) && (
            <div className="mb-3">
              <CBCheckItem
                label={t('sync.field_location')}
                box={true}
                checked={sync.includeLocation}
                onChange={(e) => { this.changeSyncValue('includeLocation', e) }}
              />
            </div>
          )}
          {(license.policy == 'all' || license.policy.includes('meeting')) && (
            <div className="mb-3">
              <CBCheckItem
                label={t('sync.field_conference')}
                box={true}
                checked={sync.includeMeeting}
                onChange={(e) => { this.changeSyncValue('includeMeeting', e) }}
              />
            </div>
          )}

          {(license.policy == 'all' || license.policy.includes('reminder')) && (
            <div>
              <CBCheckItem
                label={t('sync.field_reminders')}
                box={true}
                checked={sync.includeReminders}
                onChange={(e) => { this.changeSyncValue('includeReminders', e) }}
              />
              <div className="font-sarabun p-2 bg-neutral_1 mb-3 text-neutral_3 text-xs"> {/* Adjusted size */}
                {t('sync.reminders_description')}
              </div>
            </div>
          )}
          {(license.policy == 'all' || license.policy.includes('private')) && (
            <>
              <CBCheckItem
                label={t('sync.field_all_private')}
                box={true}
                checked={sync.allPrivate}
                onChange={(e) => { this.changeSyncValue('allPrivate', e) }}
              />
              <div className="font-sarabun p-2 bg-neutral_1 text-neutral_3 text-xs"> {/* Adjusted size */}
                {t('sync.private_description')}
              </div>
            </>
          )}
        </div>
        <div className="p-4 mb-4">
            <div className=" mb-8 p-4 flex flex-col sm:flex-row gap-4 justify-between border-neutral items-start border-2 rounded"> {/* Use flex for layout */}
              <div className="text-lg font-manrope mb-2 sm:mb-0">{t('sync.tag')}</div>
              <div className="flex-grow sm:max-w-xs"> {/* Control width */}
                <CBInput
                  disabled={sync.label == ' '}
                  value={sync.label === ' ' ? '' : sync.label} // Show empty if space
                  hint={t('sync.tag_copy_placeholder')}
                  onChange={(e) => { this.changeSyncValue('label', e) }}
                />
                <CBCheckItem
                  label={<>{t('sync.no_tag')}</>}
                  onChange={(e) => { this.changeSyncValue('label', e ? ' ' : '(copy)') }}
                  checked={sync.label == ' '}
                  className="mt-1"
                />
              </div>
            </div>
            {/* Preview might be less useful in batch mode, consider removing or simplifying */}
            {/* {sync && this.renderPreview()} */}
          </div>
      </>
    )
  }

  // DirectionForm is removed as batch sync is one-way

  getEventTitle = () => {
    const { t } = this.props;
    const { sync } = this.state;
    const labelPart = sync.label === ' ' ? '' : sync.label;

    if (!sync.includeSubject) {
      // Simplified logic based on 'free' exclusion
      if (sync.hasFilters && !sync.syncLevel.includes('free')) {
         return `${t('sync.preview_busy')} ${labelPart}`.trim();
      } else {
         return `${t('sync.preview_free_busy')} ${labelPart}`.trim();
      }
    }
    return `${t('sync.preview_your_event_subject')} ${labelPart}`.trim();
  }

  getColor = (color) => {
    switch (color) {
      case 'Green category': return '#008000';
      case 'Red category': return '#ff0000';
      case 'Yellow category': return '#ffff00';
      case 'Blue category': return '#0000ff';
      case 'Purple category': return '#800080';
      case 'Orange category': return '#ffa500';
      case '1': return '#a4bdfc';
      case '2': return '#7ae7bf';
      case '3': return '#dbadff';
      case '4': return '#ff887c';
      case '5': return '#fbd75b';
      case '6': return '#ffb878';
      case '7': return '#46d6db';
      case '8': return '#e1e1e1';
      case '9': return '#5484ed';
      case '10': return '#51b749';
      case '11': return '#D50000';
      default: return '#eee';
    }
  }

  renderPreview = () => {
     const { t } = this.props;
     const { sync } = this.state;
     // Preview needs adjustment for batch - show generic or based on global settings?
     // Showing based on global settings for now.
     if (!sync) return null;

    return (
      <div className="flex flex-col gap-y-4 border p-2 border-neutral_1 mt-4 items-center mb-4 rounded">
        <div className="text-lg font-manrope">{t('sync.subject_line_preview')}</div>
        <div className="grid lg:grid-cols-2 lg:gap-2 gap-4 grid-rows-1 w-full max-w-xl">
          <div className="flex flex-col items-center">
            <div className="text-lg mb-1">{t('sync.source')}</div>
            <div className="w-full">
              <div className="flex flex-col gap-y-1 bg-blue-100 p-2 rounded-md pl-3 text-sm">
                <div>{t('sync.preview_your_event_subject')}</div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center">
            <div className="text-lg mb-1">{t('sync.destination')}</div>
            <div className="w-full">
               <div
                 className={`flex flex-col gap-y-1 p-2 rounded-md pl-3 text-sm ${sync.destColor === 'default' ? 'bg-gray-200' : ''}`}
                 style={sync.destColor !== 'default' ? { backgroundColor: this.getColor(sync.destColor) || '#eee' } : {}}
               >
                <div>{this.getEventTitle()}</div>
                {sync.includeDescription && <div className="text-xs text-gray-600">Description...</div>}
                {sync.includeLocation && <div className="text-xs text-gray-600">Location...</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  // New method to render the preview/edit of all syncs
  handleSyncItemChange = (updatedItem, index) => {
    const updatedPairs = [...this.state.syncPairs];
    // Store the edited properties in the pair
    updatedPairs[index].editedProps = {
      tag: updatedItem.tag,
      destColor: updatedItem.destinationColor, // Use correct prop name
      matchColors: updatedItem.matchColors,
      filterColor: updatedItem.filterColor,
      syncLevel: updatedItem.syncLevel.split('|'), // Store as array
      excludeInvites: updatedItem.excludeInvites,
      hasFilters: updatedItem.hasFilters
    };
    this.setState({ syncPairs: updatedPairs });
  }

  renderSyncPreviews = () => {
    const { t } = this.props;
    return (
      <div>
        <CBHeader
          step={3} // Adjusted step number
          label={t('sync.batch_review_edit_syncs')}
          buttonLabel={t('sync.edit_previous_step')}
          buttonIcon={<Up />}
          buttonAction={(e) => { this.setState({ page: this.state.page - 1 }) }}
        />
        <div className="p-4">
          <div className="font-sarabun mt-2 mb-4 text-sm"> {/* Adjusted size */}
            {t('sync.batch_review_customize_syncs', { count: this.state.syncPairs.length })}
          </div>
          <div className="space-y-4"> {/* Add space between items */}
            {this.state.syncPairs.map((pair, index) => {
              // Build the item based on global defaults and specific edits
              const baseItem = this.buildSyncItemForPreview(pair.first, pair.second);
              const item = pair.editedProps ? { ...baseItem, ...pair.editedProps, syncLevel: pair.editedProps.syncLevel.join('|') } : baseItem; // Ensure syncLevel is string for SyncItemEdit

              return (
                <div key={index} className="mb-4">
                  <SyncItemEdit
                    item={item}
                    onItemChange={this.handleSyncItemChange}
                    index={index}
                    // Pass color options based on source type of this specific pair
                    colorOptions={this.getColorOptionsForPair(pair.first)}
                    t={t} // Pass t function
                  />
                </div>
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  // Helper to get color options for a specific source calendar type
  getColorOptionsForPair = (sourceCal) => {
     const { t } = this.props;
     const noneOption = { value: 'none', label: t('sync.none') };
     const msOptions = [
        { value: "Green category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#00ff00' }} /> Green category</div> },
        { value: "Yellow category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-yellow-200" /> Yellow category</div> },
        { value: "Red category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2 bg-red-500" /> Red category</div> },
        { value: "Orange category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'orange' }} /> Orange category</div> },
        { value: "Blue category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'blue' }} /> Blue category</div> },
        { value: "Purple category", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: 'purple' }} /> Purple category</div> },
     ];
     const googleOptions = [
        { value: "11", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#D50000' }} /> Tomato</div> },
        { value: "10", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#0B8043' }} /> Basil</div> },
        { value: "9", label: <div className="flex items-center"><div className="w-3 h-3 rounded-full mr-2" style={{ background: '#3F51B5' }} /> Blueberry</div> },
        // Add other Google colors as needed
     ];

     if (sourceCal?.calendarAccountType === 'ms') {
       return [noneOption, ...msOptions];
     } else {
       return [noneOption, ...googleOptions];
     }
   }


  getButtonLabelByStep() {
    const { t, id } = this.props;
    const { page, lastPage } = this.state; // Use adjusted lastPage

    switch (page) {
      case 0: return t('sync.continue_to_privacy');
      case 1: return t('sync.continue_to_options'); // Now privacy settings
      case 2: return t('sync.batch_continue_to_review'); // Now options/filters
      case 3: return t('sync.batch_create_syncs'); // Now review/submit
      default: return t('common.continue');
    }
  }
  render() {
    const { t, id } = this.props;
    const { page, lastPage, farthestPage, sync, allCalendars, isLoading, error, showModal, sources, syncPairs } = this.state;

    // Batch mode doesn't have single source/dest in the same way

    const pages = [
      this.SourceForm,
      this.EventDetailForm, // Privacy settings
      this.DirectionForm, // Options/Filters (DirectionForm name is misleading now) - Re-add if needed
      this.renderSyncPreviews, // Review/Edit individual syncs
    ];
    const CurrentPageForm = pages[page];

    return (
      // Replaced Layout with div
      <div className="flex flex-col md:flex-row">
        <SEO title={t('sync.create_batch_sync_title')} />
        {/* Replaced Content with main */}
        <main className="cb-content-frame bg-white flex-grow">
          <div className="cb-content-pane mobile_padding min-h-screen">
            <MediaQuery maxDeviceWidth={1224}>
              <CBSteps
                page={page}
                mobile={true}
                onPageChanged={this.changePage}
                className="mb-4"
              >
                 <CBStep
                  primary={t('sync.batch_step1_primary')} // Updated label
                  secondary={t('sync.batch_step1_secondary', { count: sources.length })}
                />
                 <CBStep
                  primary={t('sync.step2_primary')}
                  secondary={page >= 1 ? syncTypeText(sync.includeSubject, sync.includeDescription, sync.includeLocation, sync.includeReminders, sync.allPrivate, sync.includeMeeting, sync.includeAttendees, sync.includeTag) : t('sync.not_selected')}
                  disabled={sources.length === 0} // Disable if no sources selected
                />
                <CBStep
                  primary={t('sync.step3_primary')}
                  secondary={page >= 2 ? (sync.hasFilters ? t('sync.filters_applied') : t('sync.default_options')) : t('sync.not_selected')}
                  disabled={page < 1 || sources.length === 0}
                />
                 <CBStep
                  primary={t('sync.batch_step4_primary')}
                  secondary={page >= 3 ? t('sync.batch_step4_secondary_review', { count: syncPairs.length }) : t('sync.not_selected')}
                  disabled={page < 2 || sources.length === 0}
                />
              </CBSteps>
            </MediaQuery>

            {CurrentPageForm && <CurrentPageForm />}

            {error && (
               <CBAlert variant="error" message={error} className="my-4" onClose={() => this.setState({ error: null })} />
            )}

            <SubmitButton
              type={'primary'}
              block
              badge={page === lastPage ? null : page + 2} // Use state.lastPage
              size="large"
              onClick={this.nextPage}
              loading={isLoading}
              disabled={
                (page === 0 && sources.length < 2) || // Need at least 2 calendars for batch
                isLoading
              }
              className="mt-8"
            >
              {this.getButtonLabelByStep()}
            </SubmitButton>

            <CBModal
              title={t('sync.batch_review_modal_title', { count: syncPairs.length })}
              visible={showModal}
              disabled={isLoading}
              positiveLabel={isLoading ? t('common.submitting') : t('sync.batch_create_syncs')} // Updated label
              onPositiveClick={() => this.submitSync()}
              onCancelClick={() => this.setState({ isLoading: false, showModal: false })}
            >
              {showModal && (
                <div>
                  <div className="mb-4">
                    {t('sync.batch_review_modal_confirm', { count: syncPairs.length })}
                  </div>
                  <div className="max-h-[60vh] overflow-y-auto">
                    {/* Show only a few previews in the modal */}
                    {syncPairs.slice(0, 3).map((pair, index) => {
                       const baseItem = this.buildSyncItemForPreview(pair.first, pair.second);
                       // Apply edited props if they exist
                       const item = pair.editedProps ? { ...baseItem, ...pair.editedProps, syncLevel: pair.editedProps.syncLevel.join('|') } : baseItem;
                       return (
                          <div key={index} className="mb-4">
                            <SyncItem
                              preview={true}
                              item={item}
                              sourceAccountName={pair.first.email || 'N/A'}
                              destAccountName={pair.second.email || 'N/A'}
                            />
                          </div>
                       );
                    })}
                    {syncPairs.length > 3 && (
                      <div className="text-center p-4 border rounded-sm">
                        {t('sync.batch_review_modal_more', { count: syncPairs.length - 3 })}
                      </div>
                    )}
                  </div>
                </div>
              )}
            </CBModal>

          </div>
        </main>
        <MediaQuery minDeviceWidth={1224}>
           {/* Replaced Sider with aside */}
          <aside className="w-full md:w-[400px] md:flex-shrink-0 bg-gray-50 border-l border-gray-200">
            <div className="p-8 sticky top-0">
              <div className="mb-4">
                <CBHeader label={t('sync.create_batch_sync_title')} icon={<NewSync className="w-6 h-6"/>} />
              </div>
              <CBSteps
                page={page}
                onPageChanged={this.changePage}
                direction="vertical"
              >
                 <CBStep
                  primary={t('sync.batch_step1_primary')}
                  secondary={t('sync.batch_step1_secondary', { count: sources.length })}
                />
                 <CBStep
                  primary={t('sync.step2_primary')}
                  secondary={page >= 1 ? syncTypeText(sync.includeSubject, sync.includeDescription, sync.includeLocation, sync.includeReminders, sync.allPrivate, sync.includeMeeting, sync.includeAttendees, sync.includeTag) : t('sync.not_selected')}
                  disabled={sources.length === 0}
                />
                <CBStep
                  primary={t('sync.step3_primary')}
                  secondary={page >= 2 ? (sync.hasFilters ? t('sync.filters_applied') : t('sync.default_options')) : t('sync.not_selected')}
                  disabled={page < 1 || sources.length === 0}
                />
                 <CBStep
                  primary={t('sync.batch_step4_primary')}
                  secondary={page >= 3 ? t('sync.batch_step4_secondary_review', { count: syncPairs.length }) : t('sync.not_selected')}
                  disabled={page < 2 || sources.length === 0}
                />
              </CBSteps>
            </div>
          </aside>
        </MediaQuery>
      </div>
    )
  }
}

// Wrapper component to use hooks
const SyncCreatePageStateBatch = ({ id }) => { // id prop might not be needed for batch create
  const navigate = useNavigate()
  const [accounts] = useGlobalState('accounts')
  const [license] = useGlobalState('license')
  const [syncs] = useGlobalState('syncs')
  const { t } = useLocalization(); // Instantiate the hook

  // Pass necessary props to the class component
  return (
    <SyncCreatePageBatch
      id={id} // Pass id if needed, though likely not for batch create
      accounts={accounts || []}
      license={license || {}}
      syncs={syncs || []}
      navigate={navigate}
      t={t} // Pass t function as prop
    />
  )
}

export default SyncCreatePageStateBatch; // Export the wrapper
